// extracted by mini-css-extract-plugin
export var floatingButton = "scrollToTop-module--floating-button--51754";
export var floatingButton__circle = "scrollToTop-module--floating-button__circle--33172";
export var floatingButton_visible = "scrollToTop-module--floating-button_visible--b97b0";